import { Controller } from "@/controllers/Controller";

/**
 * Controller for the e-reporting API (read only : it shows what the platform knows, nothing is sent to it)
 */
export class EReportingController extends Controller {

    /**
     * Entreprise, aperçu de la prochaine déclaration, déclarations envoyées et opérations connues de la plateforme
     */
    static getOverview() {
        return this.requestBuilder("GET", "/ms-transmission/e-reporting/overview", true);
    }

    /**
     * Contenu d'une déclaration déjà envoyée à l'administration
     * @param id id de la déclaration chez la plateforme
     */
    static getDeclaration(id) {
        return this.requestBuilder("GET", `/ms-transmission/e-reporting/declaration/${id}`, true);
    }

}
